<template>
  <div>
    <b-card title="">
      <custom-g-table
        v-if="displayTable"
        ref="custom-table"
        :displayLoading="tableLoading"
        :fields="fields"
        :items="data"
        :totalRows="totalRows"
        :limit="limit"
        :hasResendButton="true"
        @changePage="onChangePage"
        @onSortChange="onSortChange"
        @onColumnFilter="onFilter"
        @onResend="onResend"
      />
    </b-card>
  </div>
</template>

<script>
import { BCard } from "bootstrap-vue";
import CustomGTable from "@/views/custom/table/CustomGTable.vue";
import sendLeadService from "@/providers/sendLeadService";
import dropdownService from "@/providers/dropdownService";
import { setRouteQuery, buildParamsRouteQuery } from "@/helpers/route-query-helper";
import { onlyLatestRequest } from "@/helpers/latest-request-helper";

export default {
  props: {
    urlQuery: Object
  },
  components: {
    BCard,
    CustomGTable,
    // CustomFilter,
  },
  data() {
    return {
      displayTable: false,
      sortField: {},
      data: [],
      totalRows: 0,
      limit: 50,
      page: 1,
      filter: {},
      tableLoading: true,
      fields: [
        // { field: "action_buttons", label: "Ações", sortable: false },
        {
          field: "dt_create",
          label: "Criação",
          type: "custom_date",
          sortable: true,
          filterOptions: {
            filterValue: '',
            enabled: true,
            placeholder: "Pesquisar por data",
            trigger: "enter",
          },
        },
        {
          field: "dt_sent",
          label: "Data de Envio",
          type: "custom_date",
          sortable: true,
          filterOptions: {
            filterValue: '',
            enabled: true,
            placeholder: "Pesquisar por data envio",
            trigger: "enter",
          },
        },
        {
          field: "dt_update",
          label: "Data de Alteração",
          type: "custom_date",
          sortable: true,
          filterOptions: {
            filterValue: '',
            enabled: true,
            placeholder: "Pesquisar por data",
            trigger: "enter",
          },
        },
        { 
          field: "sent", 
          label: "Enviado", 
          type: "boolean", 
          sortable: false, 
          filterOptions: { 
            filterValue: '', 
            enabled: true, 
            placeholder: 'Pesquisar por Enviado', 
            filterDropdownItems: [{value: true, text: 'Sim'}, {value: false, text: 'Não'}] 
          } 
        },
        {
          field: "email",
          label: "Email",
          sortable: false,
          filterOptions: {
            filterValue: '',
            enabled: true,
            placeholder: "Pesquisar por Email",
            trigger: "enter",
          },
        },
        {
          field: "errorOnSent",
          label: "Erro ao Enviar",
          type: "boolean",
          sortable: false,
          filterOptions: { 
            filterValue: '', 
            enabled: true, 
            placeholder: 'Pesquisar por Erro ao Enviar', 
            filterDropdownItems: [{value: true, text: 'Sim'}, {value: false, text: 'Não'}] 
          },
        },
        {
          field: "errorMessage",
          label: "Mensagem de erro",
          sortable: false,
          filterOptions: {
            filterValue: '',
            enabled: true,
            placeholder: "Pesquisar por Mensagem de erro",
            trigger: "enter",
          },
        },
        {
          field: "body",
          label: "Body",
          sortable: false,
        },
      ],
      origins: [],
    };
  },
  mounted() {
    this.$store.dispatch("admin/updatePageTitle", "Leads enviados");
    this.loadData();
  },
  computed: {
    searchParams() {
      const params = buildParamsRouteQuery(this.$route.query);
      params.append("page", this.page);
      params.append("limit", this.limit);

      if (this.sortField.field) {
        params.append(`sort_${this.sortField.field}`, this.sortField.type);
      }

      return params;
    },
  },
  methods: {
    onResend() {
      // todo resend email
    },
    setInitialTableFilters() {
      Object.keys(this.urlQuery).forEach(item => {
        this.fields[this.fields.findIndex(val => val.field==item)].filterOptions.filterValue = this.urlQuery[item];
      });
      this.loadData();
    },
    reportData() {
      const params = this.searchParams;
      params.append("download", true);
      sendLeadService
        .report(params)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");

          link.href = url;
          link.setAttribute("download", 'demo-request.xlsx');
          link.setAttribute("id", "link-download");

          document.body.appendChild(link);
          link.click();

          document.getElementById("link-download").remove();
        })
        .catch((err) => console.log(err));
    },
    onChangePage(page) {
      this.page = page;
      this.loadData();
    },
    onFilter(data) {
      // this.filter = data;
      // console.log("OnFilter: ", data);
      setRouteQuery(data, this.$route.query);
      this.loadData();
    },
    loadDataFilter() {
      Promise.all([
        dropdownService.getAuditlogAction(new URLSearchParams()),
        dropdownService.getAuditlogName(new URLSearchParams()),
      ])
        .then((res) => {
          this.fields[
            this.fields.findIndex((item) => item.field == "action")
          ].filterOptions.filterDropdownItems = res[0].map((item) => {
            return { value: item, text: item };
          });
          this.fields[
            this.fields.findIndex((item) => item.field == "name")
          ].filterOptions.filterDropdownItems = res[1].map((item) => {
            return { value: item, text: item };
          });
          this.setInitialTableFilters();
        })
        .catch((err) => console.log(err));
    },
    loadData() {
      this.data = [];
      this.tableLoading = true;
      // this.$refs['custom-table'].rows = [];
      // this.$refs['custom-table'].isLoading = true;
      onlyLatestRequest(this, 'loadData', sendLeadService.getall(this.searchParams))
        .then((res) => {
          this.displayTable = true;
          this.data = res.data;
          this.totalRows = res.totalRows;
          this.tableLoading = false;
        })
        .catch((err) => {
          this.displayTable = true;
          console.log(err);
        });
    },
    onSortChange(params) {
      this.sortField = params;
      this.loadData();
    },
  },
};
</script>

<style>
</style>